export default __webpack_public_path__ + "static/media/virtualWalletAvailable.6b15a137.svg";